var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPersonAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 0c4.15 0 2 5.357 2 5.357C8.464 6.43 7.929 7.5 9 8.571c.8.8 5 1.072 5 3.215v.204c0 1.11-.897 2.01-2.006 2.01H2.006C.898 14 0 13.1 0 11.99v-.204C0 9.643 3.929 9.643 5 8.57c.982-.982.614-1.964.133-2.946L5 5.357S2.85 0 7 0m7 2v2h2v2h-2v2h-2V6h-2V4h2V2z"
})));
export default SvgPersonAdd;